import Theme, {useTheme} from '@jetbrains/ring-ui-built/components/global/theme'

import {useUserTheme} from './useUserTheme'

export function useDarkOrLightTheme() {
  const userTheme = useUserTheme()
  const systemTheme = useTheme()
  return userTheme === Theme.AUTO ? systemTheme : userTheme
}
